
import { FC, useEffect, useState } from 'react';
import { FieldRow, FieldLabel, Title, ContainerInline, HeaderInline } from 'src/generic/component';
import { TextArea } from 'src/generic/component/form';
import { Button } from '@cb/apricot-react';
import { IOrgSearch } from 'src/services/org';

interface DuplicateDIConfirmationProps {
  match: IOrgSearch;
  allowReject: boolean;
  onCancel: () => void;
  onConfirm: (match: IOrgSearch) => void;
  onReject?: (reason: string) => void;
}

export const DuplicateDIConfirmation: FC<DuplicateDIConfirmationProps> = ({ allowReject, match, onCancel, onConfirm, onReject }) => {
  if (allowReject && !onReject)
    throw new Error("Must specify reject conditions when allowing rejections.");

  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState('');

  const diCode = match.di?.diCode;
  const initialReason = `Note: Investigate the possible matches below\n
${match.name} (OrgID: ${match.orgId}, DI: ${diCode})
${match.streetAddr1}
${match.city}${match.stateCd ? `, ${match.stateCd} ${match.zip5}` : `, ${match.stateOrProvince} ${match.internalPostalCd}`}
${match.countryIsoCd}`;

  useEffect(() => {
    setReason(initialReason);
  }, [match]);

  return <>
    <ContainerInline>
      <HeaderInline style={{ marginBottom: '6px' }}>
        <div style={{ display: 'inline-block' }}>
          <i style={{ marginRight: '10px' }} className="cb-icon cb-icon-circular cb-exclamation cb-red1-color" aria-hidden="true"></i>
        </div>
        <Title style={{ margin: 0 }}><strong>STOP!</strong></Title>
      </HeaderInline>
    </ContainerInline>
    <div>
      <strong>You selected an ORG with an DI code assigned. Verify in vetting notes this is the correct action!</strong>
    </div>
    <br />

    <div>
      {showReason ?
        <>
          <FieldRow>
            <FieldLabel variant="body1">Rejection Reason</FieldLabel>
            <TextArea style={{ height: '200px' }} readOnly={false} onChange={(e) => { setReason(e.target.value); }} value={reason} />
          </FieldRow>
          <Button style={{ marginRight: '10px' }} onClick={() => {
            if (onReject)
              onReject(reason);
          }}>Reject</Button>
          <Button onClick={() => {
            setShowReason(false);
          }}>Back</Button>
        </>
        :
        <>
          {match &&
            <div>
              <div style={{ fontWeight: 600 }}>
                {match.name} (OrgId: {match.orgId}, DI: {match.di?.diCode})
              </div>
              <div>
                {match.streetAddr1}
              </div>
              <div>
                {match.city}
                {match.stateCd &&
                  <>
                    ,&nbsp;{match.stateCd} {match.zip5}
                  </>
                }
              </div>
            </div>
          }
          <br />
          {allowReject &&
            <Button onClick={() => {
              if (onReject)
                onReject(initialReason);
            }} style={{ marginRight: '10px' }}>Reject for Duplicate Investigation</Button>
          }
          <Button onClick={onCancel}>Cancel</Button>
        </>
      }
    </div>
  </>;
};